export default "__VITE_ASSET__3f2338e9__"